import React from 'react';

import { Checkbox, Image } from '@lt/components';
import { useTranslation } from '@lt/localization';
import { scrollToElement } from 'src/utils/domUtils';
import { FLIGHT_LIST_ID } from '../../../containers/Flights/FlightsList/constants';

import { OPERATORS, TEST_ID_FLIGHT_CHANGE_WARNING_CHECKBOX } from './constants';
import type { FlightChangeWarningProps as Props } from './types';
import styles from './flightChangeWarning.module.css';

const FlightChangeWarning = ({
  filterByBiblioGlobus,
  airlines,
  applyFilters,
  clearFilters,
  isMobile,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleCheckboxClick = () => {
    if (!filterByBiblioGlobus?.selected) {
      const bgFilter = { ...filterByBiblioGlobus, selected: true };
      applyFilters({ path: OPERATORS, diff: bgFilter });
    } else {
      clearFilters(OPERATORS);
    }
    if (isMobile) scrollToElement(document.getElementById(FLIGHT_LIST_ID));
  };

  return (
    <div className={styles.background}>
      <div className={styles.wrapper}>
        <div className={styles.airlinesContainer}>
          {airlines.map((airline) => (
            <Image
              className={styles.airlineImage}
              key={airline[0]}
              src={airline[1]}
              fallback=""
            />
          ))}
        </div>
        <span className={styles.titleText}>
          {t('checkout.flight.changeWarningTitle')}
        </span>
        <span className={styles.text}>
          {t('checkout.flight.changeWarningText')}
        </span>
        <Checkbox
          className={styles.checkbox}
          checked={Boolean(filterByBiblioGlobus?.selected)}
          onChange={handleCheckboxClick}
          data-testid={TEST_ID_FLIGHT_CHANGE_WARNING_CHECKBOX}
        >
          <span className={styles.checkboxText}>
            {t('checkout.flight.changeWarningCheckbox')}
          </span>
        </Checkbox>
      </div>
    </div>
  );
};

export default FlightChangeWarning;
